import * as React from "react"
import { Button } from "@design/ui/button"
import { InputGroup, InputGroupAddon, InputGroupTextarea } from "@design/ui/input-group"
import { Kbd } from "@design/ui/kbd"

export interface AddinChatWiring {
  greetingGreeting?: string
  inputGroup: Omit<React.ComponentProps<typeof InputGroup>, "className" | "children">
  inputGroupContent?: React.ReactNode
  inputGroupInput?: Omit<React.ComponentProps<typeof InputGroupTextarea>, "placeholder">
  inputGroupAddon?: Omit<React.ComponentProps<typeof InputGroupAddon>, "align" | "children">
  inputGroupAddonSlot?: React.ReactNode
  button?: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "disabled" | "children">
  buttonShowIconStart?: boolean
  buttonShowKbd?: boolean
  kbd?: Omit<React.ComponentProps<typeof Kbd>, "children">
  kbdShowLeftIcon?: boolean
  kbdLabel?: string
  kbdShowRightIcon?: boolean
  buttonShowIconEnd?: boolean
  button2?: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "disabled" | "children">
}

export const AddinChatContext = React.createContext<AddinChatWiring | null>(null)

export function useWiring(): AddinChatWiring {
  const wiring = React.useContext(AddinChatContext)
  if (wiring === null) {
    throw new Error("AddinChatScreen: render inside <AddinChatContext.Provider>")
  }
  return wiring
}
